import {
  // UploadOutlined,
  DeleteOutlined,
  MoreOutlined,
  EyeOutlined,
  FormOutlined,
  CheckOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import { Avatar, Button, Dropdown, Space, Tag, Typography } from "antd";
import { BankData, ThaiBanks } from "../../Data/BankData";
import { getTableRowClassName } from "../../helpers/getRowClassName";
import { hasPermission, UXNodata } from "../../utils";
import { getIcon } from "../../helpers/getIcon";
const { Paragraph } = Typography;

export const ColumnsCustomer = (
  nameMerchang,
  CopyTextToClipboard,
  formatPromptPayNumber,
  formatAccnumID,
  tagsBageStatus,
  t,
  FormatTimeAgo,
  handleConfirm_account,
  handleShowDetail,
  handleShowEditModel,
  handleDelete,
  dropdownPlacement,
  formatName,
  customerTableParams,
  handleShowVerifyModel,
  tagsBageIcon,
  resProfileAdmin
) => [
    // ID
    {
      title: t("ID "),
      key: "id",
      dataIndex: "id",
      render: (id, record, index) => {
        const userPermissions = Array.isArray(resProfileAdmin?.permissions)
          ? resProfileAdmin.permissions
          : [];

        // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
        const accessible = hasPermission(userPermissions, "details_customer");

        return <div
          onClick={() => {
            if (!accessible) {
              // ถ้าเงื่อนไขเป็นจริง ให้แสดงข้อความแจ้งเตือนหรือทำการป้องกันการเข้าใช้งาน
              alert(t("You do not have permission to view details."));
              return; // หยุดการทำงานของฟังก์ชันต่อไป

            }
            handleShowDetail(record)
          }}
          className="text-truncate"
          title={id}
          style={{
            textWrap: "nowrap",
            width: 60,
            display: "inline-block",
            cursor: "pointer", color: "#3eacff"
          }}
        >
          <u>#{id}</u>

        </div>
      },

      sorter: false,
    },

    // merchant
    {
      title: t("Merchant"),
      filterSearch: true,
      key: "channelName",
      dataIndex: "channelName",
      sorter: false,
      render: (_e, record) => {
        return (
          <>
            {nameMerchang}
          </>
        );
      },
    },

    // customer_uuid
    {
      title: <span className="text-truncate">{t("customer_uuid")}</span>,
      filterSearch: true,
      dataIndex: "customer_uuid",
      key: "customer_uuid",
      sorter: false,
      render: (uuid, record) => {
        return (
          <div
            className="text-truncate hover"
            title={uuid}
            onClick={() => CopyTextToClipboard(uuid)}
            style={{ width: 100, cursor: "copy", color: "#767474" }}
          >
            {uuid || <UXNodata />}
          </div>
        );
      },
    },


    // name and bank
    {
      title: (
        <span className="text-truncate">
          {t("customer bank")} <br /> {t("customer name")}
        </span>
      ),
      dataIndex: "bank_code",
      key: "bank_code",
      render: (text, record) => {
        let bankCode = text === "kkp" ? "KKP" : text === "TTB" ? "ttb" : text;
        return (
          <>
            <div className="d-inline-flex " style={{ gap: 2 }}>
              <Avatar size={22} src={BankData?.find((o) => o?.bank_id === bankCode || o?.bankCode === bankCode)?.bankLogo} /> {" - "}
              <Paragraph style={{ color: "#767474" }} className="mb-2 hover fs-13" copyable={{ icon: [<CopyOutlined key="copy-icon" className="hover fs-13" style={{ color: "#767474" }} />], tooltips: null }}>{record?.account_no || <UXNodata />}</Paragraph>
            </div>
            <Paragraph style={{ color: "#767474" }} className="mb-0 hover fs-13" copyable={{ icon: [<CopyOutlined key="copy-icon" className="hover fs-13" style={{ color: "#767474" }} />], tooltips: null }}>{record?.name || <UXNodata />}</Paragraph>
          </>
        );
      },
      filters: ThaiBanks,
      onFilter: (value, record) => record?.bank_code.includes(value),
      filterSearch: true,
    },

    // telephone number
    {
      title: t("telephoneNumber"),
      key: "telephoneNumber",
      dataIndex: "telephoneNumber",
      render: (item) => (
        <>
          {!item ? <UXNodata /> :<Paragraph  style={{color: "#767474"}}  className="mb-0 hover fs-13" copyable={{icon: [<CopyOutlined key="copy-icon" className="hover fs-13" style={{color: "#767474"}} />],tooltips: null}}>{item}</Paragraph>}
        </>
      ),

      sorter: false,
    },

    // status
    {
      title: t("status"),
      dataIndex: "status",
      key: "status",
      render: (status, record) => {
        let active = status === "SUCCESS" ? "Active": status;
        return (
          <span
            className="text-truncate"
            style={{ display: "inline-flex", alignItems: "center" }}
          >
            <Tag
              style={{ textTransform: "capitalize", fontWeight: "700" }}
              color={tagsBageStatus(status)}
              icon={getIcon(status)}
              className={getTableRowClassName(status)}
              key={status}
            >
              {t(active) || <UXNodata />}
            </Tag>{" "}
          </span>
        );
      },
    },

    // createdAt
    {
      title: t("createdAt"),
      filterSearch: true,
      dataIndex: "created_at",
      key: "created_at",
      sorter: false,
      render: (date) => (
        <span
          style={{ maxWidth: "100%", display: "inline-block" }}
          className="text-truncate"
        >
          {FormatTimeAgo(date)}
        </span>
      ),
    },

    // action
    {
      title: <span className=" text-truncate">{t("action")}</span>,
      render: (_, record) => {
        const userPermissions = Array.isArray(resProfileAdmin?.permissions)
          ? resProfileAdmin.permissions
          : [];


        let statusPending = record?.status === "PENDING" && hasPermission(userPermissions, "verify_customer");
        let sta = `${record?.status + 2}`;



        // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
        const menuItems = [];
        if (hasPermission(userPermissions, "details_customer")) {
          menuItems.push({
            key: "Details",
            icon: <EyeOutlined />,
            label: t("Details"),
            onClick: () => handleShowDetail(record),
          });
        }

        if (hasPermission(userPermissions, "edit_customer")) {
          menuItems.push({
            key: "Edit",
            icon: <FormOutlined />,
            label: t("edit"),
            onClick: () => handleShowEditModel(record),
          });
        }

        if (hasPermission(userPermissions, "del_customer")) {
          menuItems.push({
            key: "Delete",
            icon: <DeleteOutlined />,
            label: t("Delete"),
            danger: true, // Ant Design จะเปลี่ยนเป็นสีแดงให้
            onClick: () => handleDelete(record),
          });
        }

        // ถ้าไม่มีสิทธิ์อะไรเลย ไม่ต้องโชว์ปุ่ม Dropdown
        if (menuItems.length === 0) return null;
        return (
          <Space size="middle" className=" text-truncate">
            {statusPending ? (
              <>
                <Button
                  size="small"
                  color={"primary"}
                  icon={<CheckOutlined />}
                  onClick={() =>
                    handleConfirm_account(record)
                  }
                  variant="outlined"
                >
                  {t(sta)}
                </Button>
              </>
            ) : (
              <>
                {/*  */}
                <div className="md-show">
                  <Dropdown
                    arrow={true}
                    trigger={["click"]}
                    placement={dropdownPlacement}
                    menu={{ items: menuItems }}
                    align="start"
                  >
                    <Button shape="circle">
                      <MoreOutlined
                        style={{ color: "#5A5A5A" }}
                        id="MoreOutlined"
                      />
                    </Button>
                  </Dropdown>
                </div>
              </>
            )}
          </Space>
        );
      },
    },
  ];
